import user from '@/api/user'
import role from '@/api/role'
import permission from '@/api/permission'
import department from '@/api/department'
import account from '@/api/account'
import workTime from '@/api/workTime'
import workType from '@/api/workType'
import system from '@/api/system'
import router from '@/api/router'
import collector from '@/api/collector'
import collectorGroup from '@/api/collectorGroup'
import people from '@/api/people'
import product from '@/api/product'
import order from '@/api/order'
import maintain from '@/api/maintain'
import collectorPlan from '@/api/collectorPlan'
import monitor from '@/api/monitor'
import card from '@/api/card'
import computeType from '@/api/computeType'
import productionPlan from '@/api/productionPlan'
import systemAuth from '@/api/systemAuth'
import orderPlan from '@/api/orderPlan'
import data from '@/api/data'

export const Api = {
  user,
  role,
  permission,
  department,
  account,
  workTime,
  workType,
  system,
  router,
  collector,
  people,
  product,
  order,
  maintain,
  collectorPlan,
  collectorGroup,
  monitor,
  card,
  computeType,
  productionPlan,
  orderPlan,
  systemAuth,
  data
}

export default {
  install (Vue) {
    Object.defineProperty(Vue.prototype, '$api', { value: Api })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js